import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode } from "vue"
import _imports_0 from '@/assets/area_map_chiba.png'


const _hoisted_1 = { class: "area-map" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, "AREA MAP", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "caption" }, "※MAPはタップしていただくと拡大できます", -1)
const _hoisted_4 = { class: "image" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = {
  key: 0,
  class: "modal"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "image" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.showModal && _ctx.showModal(...args)))
      }, _hoisted_6)
    ]),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (_ctx.show)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("button", {
                class: "close",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
              }),
              _hoisted_8
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}